export const AE_RANDOM_ID = 'AE_eF-3f9FZr';

export const COUNTRIES = [
  {
    id: '60e4482c7cb7d4bc4849c4d5',
    placeholder: '1078286109',
    codeNumber: '+20',
    codeNumberArabic: '20+',
    codeName: 'EG',
    code: 'EG',
    displayName: 'Egypt +20',
    display: true,
    name: 'Egypt',
    arabicName: 'مصر'
  },
  {
    id: 'eF-3f9FZr',
    placeholder: '12345678',
    codeNumber: '+966',
    codeNumberArabic: '966+',
    codeName: 'SA',
    code: 'SA',
    displayName: 'Saudi Arabia +966',
    display: true,
    name: 'Saudi Arabia',
    arabicName: 'السعودية'
  },
  {
    id: AE_RANDOM_ID,
    placeholder: '12345678',
    codeNumber: '+971',
    codeNumberArabic: '971+',
    codeName: 'AE',
    code: 'SA',
    displayName: 'United Arab Emirates +971',
    display: true,
    name: 'United Arab Emirates',
    arabicName: 'الإمارات العربية المتحدة'
  }

  // {
  //   codeNumber: '+93',
  //   codeName: 'AF',
  //   displayName: 'Afghanistan +93'
  // },
  // {
  //   codeNumber: '+358',
  //   codeName: 'AX',
  //   displayName: 'Åland Islands +358'
  // },
  // {
  //   codeNumber: '+355',
  //   codeName: 'AL',
  //   displayName: 'Albania +355'
  // },
  // {
  //   codeNumber: '+213',
  //   codeName: 'DZ',
  //   displayName: 'Algeria +213'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'AS',
  //   displayName: 'American Samoa +1'
  // },
  // {
  //   codeNumber: '+376',
  //   codeName: 'AD',
  //   displayName: 'Andorra +376'
  // },
  // {
  //   codeNumber: '+244',
  //   codeName: 'AO',
  //   displayName: 'Angola +244'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'AI',
  //   displayName: 'Anguilla +1'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'AG',
  //   displayName: 'Antigua and Barbuda +1'
  // },
  // {
  //   codeNumber: '+54',
  //   codeName: 'AR',
  //   displayName: 'Argentina +54'
  // },
  // {
  //   codeNumber: '+374',
  //   codeName: 'AM',
  //   displayName: 'Armenia +374'
  // },
  // {
  //   codeNumber: '+297',
  //   codeName: 'AW',
  //   displayName: 'Aruba +297'
  // },
  // {
  //   codeNumber: '+61',
  //   codeName: 'AU',
  //   displayName: 'Australia +61'
  // },
  // {
  //   codeNumber: '+43',
  //   codeName: 'AT',
  //   displayName: 'Austria +43'
  // },
  // {
  //   codeNumber: '+994',
  //   codeName: 'AZ',
  //   displayName: 'Azerbaijan +994'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'BS',
  //   displayName: 'Bahamas +1'
  // },
  // {
  //   codeNumber: '+973',
  //   codeName: 'BH',
  //   displayName: 'Bahrain +973'
  // },
  // {
  //   codeNumber: '+880',
  //   codeName: 'BD',
  //   displayName: 'Bangladesh +880'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'BB',
  //   displayName: 'Barbados +1'
  // },
  // {
  //   codeNumber: '+375',
  //   codeName: 'BY',
  //   displayName: 'Belarus +375'
  // },
  // {
  //   codeNumber: '+32',
  //   codeName: 'BE',
  //   displayName: 'Belgium +32'
  // },
  // {
  //   codeNumber: '+501',
  //   codeName: 'BZ',
  //   displayName: 'Belize +501'
  // },
  // {
  //   codeNumber: '+229',
  //   codeName: 'BJ',
  //   displayName: 'Benin +229'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'BM',
  //   displayName: 'Bermuda +1'
  // },
  // {
  //   codeNumber: '+975',
  //   codeName: 'BT',
  //   displayName: 'Bhutan +975'
  // },
  // {
  //   codeNumber: '+591',
  //   codeName: 'BO',
  //   displayName: 'Bolivia +591'
  // },
  // {
  //   codeNumber: '+387',
  //   codeName: 'BA',
  //   displayName: 'Bosnia and Herzegovina +387'
  // },
  // {
  //   codeNumber: '+267',
  //   codeName: 'BW',
  //   displayName: 'Botswana +267'
  // },
  // {
  //   codeNumber: '+55',
  //   codeName: 'BR',
  //   displayName: 'Brazil +55'
  // },
  // {
  //   codeNumber: '+246',
  //   codeName: 'IO',
  //   displayName: 'British Indian Ocean Territory +246'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'VG',
  //   displayName: 'British Virgin Islands +1'
  // },
  // {
  //   codeNumber: '+673',
  //   codeName: 'BN',
  //   displayName: 'Brunei +673'
  // },
  // {
  //   codeNumber: '+359',
  //   codeName: 'BG',
  //   displayName: 'Bulgaria +359'
  // },
  // {
  //   codeNumber: '+226',
  //   codeName: 'BF',
  //   displayName: 'Burkina Faso +226'
  // },
  // {
  //   codeNumber: '+257',
  //   codeName: 'BI',
  //   displayName: 'Burundi +257'
  // },
  // {
  //   codeNumber: '+855',
  //   codeName: 'KH',
  //   displayName: 'Cambodia +855'
  // },
  // {
  //   codeNumber: '+237',
  //   codeName: 'CM',
  //   displayName: 'Cameroon +237'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'CA',
  //   displayName: 'Canada +1'
  // },
  // {
  //   codeNumber: '+238',
  //   codeName: 'CV',
  //   displayName: 'Cape Verde +238'
  // },
  // {
  //   codeNumber: '+599',
  //   codeName: 'BQ',
  //   displayName: 'Caribbean Netherlands +599'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'KY',
  //   displayName: 'Cayman Islands +1'
  // },
  // {
  //   codeNumber: '+236',
  //   codeName: 'CF',
  //   displayName: 'Central African Republic +236'
  // },
  // {
  //   codeNumber: '+235',
  //   codeName: 'TD',
  //   displayName: 'Chad +235'
  // },
  // {
  //   codeNumber: '+56',
  //   codeName: 'CL',
  //   displayName: 'Chile +56'
  // },
  // {
  //   codeNumber: '+86',
  //   codeName: 'CN',
  //   displayName: 'China +86'
  // },
  // {
  //   codeNumber: '+61',
  //   codeName: 'CX',
  //   displayName: 'Christmas Island +61'
  // },
  // {
  //   codeNumber: '+61',
  //   codeName: 'CC',
  //   displayName: 'Cocos +61'
  // },
  // {
  //   codeNumber: '+57',
  //   codeName: 'CO',
  //   displayName: 'Colombia +57'
  // },
  // {
  //   codeNumber: '+269',
  //   codeName: 'KM',
  //   displayName: 'Comoros +269'
  // },
  // {
  //   codeNumber: '+243',
  //   codeName: 'CD',
  //   displayName: 'Democratic Republic Congo +243'
  // },
  // {
  //   codeNumber: '+242',
  //   codeName: 'CG',
  //   displayName: 'Republic of Congo +242'
  // },
  // {
  //   codeNumber: '+682',
  //   codeName: 'CK',
  //   displayName: 'Cook Islands +682'
  // },
  // {
  //   codeNumber: '+506',
  //   codeName: 'CR',
  //   displayName: 'Costa Rica +506'
  // },
  // {
  //   codeNumber: '+225',
  //   codeName: 'CI',
  //   displayName: "Côte d'Ivoire +225"
  // },
  // {
  //   codeNumber: '+385',
  //   codeName: 'HR',
  //   displayName: 'Croatia +385'
  // },
  // {
  //   codeNumber: '+53',
  //   codeName: 'CU',
  //   displayName: 'Cuba +53'
  // },
  // {
  //   codeNumber: '+599',
  //   codeName: 'CW',
  //   displayName: 'Curaçao +599'
  // },
  // {
  //   codeNumber: '+357',
  //   codeName: 'CY',
  //   displayName: 'Cyprus +357'
  // },
  // {
  //   codeNumber: '+420',
  //   codeName: 'CZ',
  //   displayName: 'Czech Republic +420'
  // },
  // {
  //   codeNumber: '+45',
  //   codeName: 'DK',
  //   displayName: 'Denmark +45'
  // },
  // {
  //   codeNumber: '+253',
  //   codeName: 'DJ',
  //   displayName: 'Djibouti +253'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'DM',
  //   displayName: 'Dominica +1'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'DO',
  //   displayName: 'Dominican Republic +1'
  // },
  // {
  //   codeNumber: '+670',
  //   codeName: 'TL',
  //   displayName: 'East Timor +670'
  // },
  // {
  //   codeNumber: '+593',
  //   codeName: 'EC',
  //   displayName: 'Ecuador +593'
  // },
  // {
  //   codeNumber: '+20',
  //   codeName: 'EG',
  //   displayName: 'Egypt +20'
  // },
  // {
  //   codeNumber: '+503',
  //   codeName: 'SV',
  //   displayName: 'El Salvador +503'
  // },
  // {
  //   codeNumber: '+240',
  //   codeName: 'GQ',
  //   displayName: 'Equatorial Guinea +240'
  // },
  // {
  //   codeNumber: '+291',
  //   codeName: 'ER',
  //   displayName: 'Eritrea +291'
  // },
  // {
  //   codeNumber: '+372',
  //   codeName: 'EE',
  //   displayName: 'Estonia +372'
  // },
  // {
  //   codeNumber: '+251',
  //   codeName: 'ET',
  //   displayName: 'Ethiopia +251'
  // },
  // {
  //   codeNumber: '+500',
  //   codeName: 'FK',
  //   displayName: 'Falkland Islands +500'
  // },
  // {
  //   codeNumber: '+298',
  //   codeName: 'FO',
  //   displayName: 'Faroe Islands +298'
  // },
  // {
  //   codeNumber: '+679',
  //   codeName: 'FJ',
  //   displayName: 'Fiji +679'
  // },
  // {
  //   codeNumber: '+358',
  //   codeName: 'FI',
  //   displayName: 'Finland +358'
  // },
  // {
  //   codeNumber: '+33',
  //   codeName: 'FR',
  //   displayName: 'France +33'
  // },
  // {
  //   codeNumber: '+594',
  //   codeName: 'GF',
  //   displayName: 'French Guiana +594'
  // },
  // {
  //   codeNumber: '+689',
  //   codeName: 'PF',
  //   displayName: 'French Polynesia +689'
  // },
  // {
  //   codeNumber: '+241',
  //   codeName: 'GA',
  //   displayName: 'Gabon +241'
  // },
  // {
  //   codeNumber: '+220',
  //   codeName: 'GM',
  //   displayName: 'Gambia +220'
  // },
  // {
  //   codeNumber: '+995',
  //   codeName: 'GE',
  //   displayName: 'Georgia +995'
  // },
  // {
  //   codeNumber: '+49',
  //   codeName: 'DE',
  //   displayName: 'Germany +49'
  // },
  // {
  //   codeNumber: '+233',
  //   codeName: 'GH',
  //   displayName: 'Ghana +233'
  // },
  // {
  //   codeNumber: '+350',
  //   codeName: 'GI',
  //   displayName: 'Gibraltar +350'
  // },
  // {
  //   codeNumber: '+30',
  //   codeName: 'GR',
  //   displayName: 'Greece +30'
  // },
  // {
  //   codeNumber: '+299',
  //   codeName: 'GL',
  //   displayName: 'Greenland +299'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'GD',
  //   displayName: 'Grenada +1'
  // },
  // {
  //   codeNumber: '+590',
  //   codeName: 'GP',
  //   displayName: 'Guadeloupe +590'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'GU',
  //   displayName: 'Guam +1'
  // },
  // {
  //   codeNumber: '+502',
  //   codeName: 'GT',
  //   displayName: 'Guatemala +502'
  // },
  // {
  //   codeNumber: '+44',
  //   codeName: 'GG',
  //   displayName: 'Guernsey +44'
  // },
  // {
  //   codeNumber: '+224',
  //   codeName: 'GN',
  //   displayName: 'Guinea Conakry +224'
  // },
  // {
  //   codeNumber: '+245',
  //   codeName: 'GW',
  //   displayName: 'Guinea-Bissau +245'
  // },
  // {
  //   codeNumber: '+592',
  //   codeName: 'GY',
  //   displayName: 'Guyana +592'
  // },
  // {
  //   codeNumber: '+509',
  //   codeName: 'HT',
  //   displayName: 'Haiti +509'
  // },
  // {
  //   codeNumber: '+672',
  //   codeName: 'HM',
  //   displayName: 'Heard Island and McDonald Islands +672'
  // },
  // {
  //   codeNumber: '+504',
  //   codeName: 'HN',
  //   displayName: 'Honduras +504'
  // },
  // {
  //   codeNumber: '+852',
  //   codeName: 'HK',
  //   displayName: 'Hong Kong +852'
  // },
  // {
  //   codeNumber: '+36',
  //   codeName: 'HU',
  //   displayName: 'Hungary +36'
  // },
  // {
  //   codeNumber: '+354',
  //   codeName: 'IS',
  //   displayName: 'Iceland +354'
  // },
  // {
  //   codeNumber: '+91',
  //   codeName: 'IN',
  //   displayName: 'India +91'
  // },
  // {
  //   codeNumber: '+62',
  //   codeName: 'ID',
  //   displayName: 'Indonesia +62'
  // },
  // {
  //   codeNumber: '+98',
  //   codeName: 'IR',
  //   displayName: 'Iran +98'
  // },
  // {
  //   codeNumber: '+964',
  //   codeName: 'IQ',
  //   displayName: 'Iraq +964'
  // },
  // {
  //   codeNumber: '+353',
  //   codeName: 'IE',
  //   displayName: 'Ireland +353'
  // },
  // {
  //   codeNumber: '+44',
  //   codeName: 'IM',
  //   displayName: 'Isle of Man +44'
  // },
  // {
  //   codeNumber: '+972',
  //   codeName: 'IL',
  //   displayName: 'Israel +972'
  // },
  // {
  //   codeNumber: '+39',
  //   codeName: 'IT',
  //   displayName: 'Italy +39'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'JM',
  //   displayName: 'Jamaica +1'
  // },
  // {
  //   codeNumber: '+81',
  //   codeName: 'JP',
  //   displayName: 'Japan +81'
  // },
  // {
  //   codeNumber: '+44',
  //   codeName: 'JE',
  //   displayName: 'Jersey +44'
  // },
  // {
  //   codeNumber: '+962',
  //   codeName: 'JO',
  //   displayName: 'Jordan +962'
  // },
  // {
  //   codeNumber: '+7',
  //   codeName: 'KZ',
  //   displayName: 'Kazakhstan +7'
  // },
  // {
  //   codeNumber: '+254',
  //   codeName: 'KE',
  //   displayName: 'Kenya +254'
  // },
  // {
  //   codeNumber: '+686',
  //   codeName: 'KI',
  //   displayName: 'Kiribati +686'
  // },
  // {
  //   codeNumber: '+965',
  //   codeName: 'KW',
  //   displayName: 'Kuwait +965'
  // },
  // {
  //   codeNumber: '+996',
  //   codeName: 'KG',
  //   displayName: 'Kyrgyzstan +996'
  // },
  // {
  //   codeNumber: '+856',
  //   codeName: 'LA',
  //   displayName: 'Laos +856'
  // },
  // {
  //   codeNumber: '+371',
  //   codeName: 'LV',
  //   displayName: 'Latvia +371'
  // },
  // {
  //   codeNumber: '+961',
  //   codeName: 'LB',
  //   displayName: 'Lebanon +961'
  // },
  // {
  //   codeNumber: '+266',
  //   codeName: 'LS',
  //   displayName: 'Lesotho +266'
  // },
  // {
  //   codeNumber: '+231',
  //   codeName: 'LR',
  //   displayName: 'Liberia +231'
  // },
  // {
  //   codeNumber: '+218',
  //   codeName: 'LY',
  //   displayName: 'Libya +218'
  // },
  // {
  //   codeNumber: '+423',
  //   codeName: 'LI',
  //   displayName: 'Liechtenstein +423'
  // },
  // {
  //   codeNumber: '+370',
  //   codeName: 'LT',
  //   displayName: 'Lithuania +370'
  // },
  // {
  //   codeNumber: '+352',
  //   codeName: 'LU',
  //   displayName: 'Luxembourg +352'
  // },
  // {
  //   codeNumber: '+853',
  //   codeName: 'MO',
  //   displayName: 'Macau +853'
  // },
  // {
  //   codeNumber: '+389',
  //   codeName: 'MK',
  //   displayName: 'Macedonia +389'
  // },
  // {
  //   codeNumber: '+261',
  //   codeName: 'MG',
  //   displayName: 'Madagascar +261'
  // },
  // {
  //   codeNumber: '+265',
  //   codeName: 'MW',
  //   displayName: 'Malawi +265'
  // },
  // {
  //   codeNumber: '+60',
  //   codeName: 'MY',
  //   displayName: 'Malaysia +60'
  // },
  // {
  //   codeNumber: '+960',
  //   codeName: 'MV',
  //   displayName: 'Maldives +960'
  // },
  // {
  //   codeNumber: '+223',
  //   codeName: 'ML',
  //   displayName: 'Mali +223'
  // },
  // {
  //   codeNumber: '+356',
  //   codeName: 'MT',
  //   displayName: 'Malta +356'
  // },
  // {
  //   codeNumber: '+692',
  //   codeName: 'MH',
  //   displayName: 'Marshall Islands +692'
  // },
  // {
  //   codeNumber: '+596',
  //   codeName: 'MQ',
  //   displayName: 'Martinique +596'
  // },
  // {
  //   codeNumber: '+222',
  //   codeName: 'MR',
  //   displayName: 'Mauritania +222'
  // },
  // {
  //   codeNumber: '+230',
  //   codeName: 'MU',
  //   displayName: 'Mauritius +230'
  // },
  // {
  //   codeNumber: '+262',
  //   codeName: 'YT',
  //   displayName: 'Mayotte +262'
  // },
  // {
  //   codeNumber: '+52',
  //   codeName: 'MX',
  //   displayName: 'Mexico +52'
  // },
  // {
  //   codeNumber: '+691',
  //   codeName: 'FM',
  //   displayName: 'Micronesia +691'
  // },
  // {
  //   codeNumber: '+373',
  //   codeName: 'MD',
  //   displayName: 'Moldova +373'
  // },
  // {
  //   codeNumber: '+377',
  //   codeName: 'MC',
  //   displayName: 'Monaco +377'
  // },
  // {
  //   codeNumber: '+976',
  //   codeName: 'MN',
  //   displayName: 'Mongolia +976'
  // },
  // {
  //   codeNumber: '+382',
  //   codeName: 'ME',
  //   displayName: 'Montenegro +382'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'MS',
  //   displayName: 'Montserrat +1'
  // },
  // {
  //   codeNumber: '+212',
  //   codeName: 'MA',
  //   displayName: 'Morocco +212'
  // },
  // {
  //   codeNumber: '+258',
  //   codeName: 'MZ',
  //   displayName: 'Mozambique +258'
  // },
  // {
  //   codeNumber: '+95',
  //   codeName: 'MM',
  //   displayName: 'Myanmar +95'
  // },
  // {
  //   codeNumber: '+264',
  //   codeName: 'NA',
  //   displayName: 'Namibia +264'
  // },
  // {
  //   codeNumber: '+674',
  //   codeName: 'NR',
  //   displayName: 'Nauru +674'
  // },
  // {
  //   codeNumber: '+977',
  //   codeName: 'NP',
  //   displayName: 'Nepal +977'
  // },
  // {
  //   codeNumber: '+31',
  //   codeName: 'NL',
  //   displayName: 'Netherlands +31'
  // },
  // {
  //   codeNumber: '+687',
  //   codeName: 'NC',
  //   displayName: 'New Caledonia +687'
  // },
  // {
  //   codeNumber: '+64',
  //   codeName: 'NZ',
  //   displayName: 'New Zealand +64'
  // },
  // {
  //   codeNumber: '+505',
  //   codeName: 'NI',
  //   displayName: 'Nicaragua +505'
  // },
  // {
  //   codeNumber: '+227',
  //   codeName: 'NE',
  //   displayName: 'Niger +227'
  // },
  // {
  //   codeNumber: '+234',
  //   codeName: 'NG',
  //   displayName: 'Nigeria +234'
  // },
  // {
  //   codeNumber: '+683',
  //   codeName: 'NU',
  //   displayName: 'Niue +683'
  // },
  // {
  //   codeNumber: '+672',
  //   codeName: 'NF',
  //   displayName: 'Norfolk Island +672'
  // },
  // {
  //   codeNumber: '+850',
  //   codeName: 'KP',
  //   displayName: 'North Korea +850'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'MP',
  //   displayName: 'Northern Mariana Islands +1'
  // },
  // {
  //   codeNumber: '+47',
  //   codeName: 'NO',
  //   displayName: 'Norway +47'
  // },
  // {
  //   codeNumber: '+968',
  //   codeName: 'OM',
  //   displayName: 'Oman +968'
  // },
  // {
  //   codeNumber: '+92',
  //   codeName: 'PK',
  //   displayName: 'Pakistan +92'
  // },
  // {
  //   codeNumber: '+680',
  //   codeName: 'PW',
  //   displayName: 'Palau +680'
  // },
  // {
  //   codeNumber: '+970',
  //   codeName: 'PS',
  //   displayName: 'Palestinian Territories +970'
  // },
  // {
  //   codeNumber: '+507',
  //   codeName: 'PA',
  //   displayName: 'Panama +507'
  // },
  // {
  //   codeNumber: '+675',
  //   codeName: 'PG',
  //   displayName: 'Papua New Guinea +675'
  // },
  // {
  //   codeNumber: '+595',
  //   codeName: 'PY',
  //   displayName: 'Paraguay +595'
  // },
  // {
  //   codeNumber: '+51',
  //   codeName: 'PE',
  //   displayName: 'Peru +51'
  // },
  // {
  //   codeNumber: '+63',
  //   codeName: 'PH',
  //   displayName: 'Philippines +63'
  // },
  // {
  //   codeNumber: '+48',
  //   codeName: 'PL',
  //   displayName: 'Poland +48'
  // },
  // {
  //   codeNumber: '+351',
  //   codeName: 'PT',
  //   displayName: 'Portugal +351'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'PR',
  //   displayName: 'Puerto Rico +1'
  // },
  // {
  //   codeNumber: '+974',
  //   codeName: 'QA',
  //   displayName: 'Qatar +974'
  // },
  // {
  //   codeNumber: '+262',
  //   codeName: 'RE',
  //   displayName: 'Réunion +262'
  // },
  // {
  //   codeNumber: '+40',
  //   codeName: 'RO',
  //   displayName: 'Romania +40'
  // },
  // {
  //   codeNumber: '+7',
  //   codeName: 'RU',
  //   displayName: 'Russia +7'
  // },
  // {
  //   codeNumber: '+250',
  //   codeName: 'RW',
  //   displayName: 'Rwanda +250'
  // },
  // {
  //   codeNumber: '+590',
  //   codeName: 'BL',
  //   displayName: 'Saint Barthélemy +590'
  // },
  // {
  //   codeNumber: '+290',
  //   codeName: 'SH',
  //   displayName: 'Saint Helena +290'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'KN',
  //   displayName: 'St. Kitts +1'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'LC',
  //   displayName: 'St. Lucia +1'
  // },
  // {
  //   codeNumber: '+590',
  //   codeName: 'MF',
  //   displayName: 'Saint Martin +590'
  // },
  // {
  //   codeNumber: '+508',
  //   codeName: 'PM',
  //   displayName: 'Saint Pierre and Miquelon +508'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'VC',
  //   displayName: 'St. Vincent +1'
  // },
  // {
  //   codeNumber: '+685',
  //   codeName: 'WS',
  //   displayName: 'Samoa +685'
  // },
  // {
  //   codeNumber: '+378',
  //   codeName: 'SM',
  //   displayName: 'San Marino +378'
  // },
  // {
  //   codeNumber: '+239',
  //   codeName: 'ST',
  //   displayName: 'São Tomé and Príncipe +239'
  // },
  // {
  //   codeNumber: '+966',
  //   codeName: 'SA',
  //   displayName: 'Saudi Arabia +966'
  // },
  // {
  //   codeNumber: '+221',
  //   codeName: 'SN',
  //   displayName: 'Senegal +221'
  // },
  // {
  //   codeNumber: '+381',
  //   codeName: 'RS',
  //   displayName: 'Serbia +381'
  // },
  // {
  //   codeNumber: '+248',
  //   codeName: 'SC',
  //   displayName: 'Seychelles +248'
  // },
  // {
  //   codeNumber: '+232',
  //   codeName: 'SL',
  //   displayName: 'Sierra Leone +232'
  // },
  // {
  //   codeNumber: '+65',
  //   codeName: 'SG',
  //   displayName: 'Singapore +65'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'SX',
  //   displayName: 'Sint Maarten +1'
  // },
  // {
  //   codeNumber: '+421',
  //   codeName: 'SK',
  //   displayName: 'Slovakia +421'
  // },
  // {
  //   codeNumber: '+386',
  //   codeName: 'SI',
  //   displayName: 'Slovenia +386'
  // },
  // {
  //   codeNumber: '+677',
  //   codeName: 'SB',
  //   displayName: 'Solomon Islands +677'
  // },
  // {
  //   codeNumber: '+252',
  //   codeName: 'SO',
  //   displayName: 'Somalia +252'
  // },
  // {
  //   codeNumber: '+27',
  //   codeName: 'ZA',
  //   displayName: 'South Africa +27'
  // },
  // {
  //   codeNumber: '+500',
  //   codeName: 'GS',
  //   displayName: 'South Georgia and the South Sandwich Islands +500'
  // },
  // {
  //   codeNumber: '+82',
  //   codeName: 'KR',
  //   displayName: 'South Korea +82'
  // },
  // {
  //   codeNumber: '+211',
  //   codeName: 'SS',
  //   displayName: 'South Sudan +211'
  // },
  // {
  //   codeNumber: '+34',
  //   codeName: 'ES',
  //   displayName: 'Spain +34'
  // },
  // {
  //   codeNumber: '+94',
  //   codeName: 'LK',
  //   displayName: 'Sri Lanka +94'
  // },
  // {
  //   codeNumber: '+249',
  //   codeName: 'SD',
  //   displayName: 'Sudan +249'
  // },
  // {
  //   codeNumber: '+597',
  //   codeName: 'SR',
  //   displayName: 'Suriname +597'
  // },
  // {
  //   codeNumber: '+47',
  //   codeName: 'SJ',
  //   displayName: 'Svalbard and Jan Mayen +47'
  // },
  // {
  //   codeNumber: '+268',
  //   codeName: 'SZ',
  //   displayName: 'Swaziland +268'
  // },
  // {
  //   codeNumber: '+46',
  //   codeName: 'SE',
  //   displayName: 'Sweden +46'
  // },
  // {
  //   codeNumber: '+41',
  //   codeName: 'CH',
  //   displayName: 'Switzerland +41'
  // },
  // {
  //   codeNumber: '+963',
  //   codeName: 'SY',
  //   displayName: 'Syria +963'
  // },
  // {
  //   codeNumber: '+886',
  //   codeName: 'TW',
  //   displayName: 'Taiwan +886'
  // },
  // {
  //   codeNumber: '+992',
  //   codeName: 'TJ',
  //   displayName: 'Tajikistan +992'
  // },
  // {
  //   codeNumber: '+255',
  //   codeName: 'TZ',
  //   displayName: 'Tanzania +255'
  // },
  // {
  //   codeNumber: '+66',
  //   codeName: 'TH',
  //   displayName: 'Thailand +66'
  // },
  // {
  //   codeNumber: '+228',
  //   codeName: 'TG',
  //   displayName: 'Togo +228'
  // },
  // {
  //   codeNumber: '+690',
  //   codeName: 'TK',
  //   displayName: 'Tokelau +690'
  // },
  // {
  //   codeNumber: '+676',
  //   codeName: 'TO',
  //   displayName: 'Tonga +676'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'TT',
  //   displayName: 'Trinidad/Tobago +1'
  // },
  // {
  //   codeNumber: '+216',
  //   codeName: 'TN',
  //   displayName: 'Tunisia +216'
  // },
  // {
  //   codeNumber: '+90',
  //   codeName: 'TR',
  //   displayName: 'Turkey +90'
  // },
  // {
  //   codeNumber: '+993',
  //   codeName: 'TM',
  //   displayName: 'Turkmenistan +993'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'TC',
  //   displayName: 'Turks and Caicos Islands +1'
  // },
  // {
  //   codeNumber: '+688',
  //   codeName: 'TV',
  //   displayName: 'Tuvalu +688'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'VI',
  //   displayName: 'U.S. Virgin Islands (VI) +1'
  // },
  // {
  //   codeNumber: '+256',
  //   codeName: 'UG',
  //   displayName: 'Uganda (UG) +256'
  // },
  // {
  //   codeNumber: '+380',
  //   codeName: 'UA',
  //   displayName: 'Ukraine (UA) +380'
  // },
  // {
  //   codeNumber: '+971',
  //   codeName: 'AE',
  //   displayName: 'United Arab Emirates (AE) +971'
  // },
  // {
  //   codeNumber: '+44',
  //   codeName: 'GB',
  //   displayName: 'United Kingdom (GB) +44'
  // },
  // {
  //   codeNumber: '+1',
  //   codeName: 'US',
  //   displayName: 'United States +1'
  // },
  // {
  //   codeNumber: '+598',
  //   codeName: 'UY',
  //   displayName: 'Uruguay +598'
  // },
  // {
  //   codeNumber: '+998',
  //   codeName: 'UZ',
  //   displayName: 'Uzbekistan +998'
  // },
  // {
  //   codeNumber: '+678',
  //   codeName: 'VU',
  //   displayName: 'Vanuatu (VU) +678'
  // },
  // {
  //   codeNumber: '+379',
  //   codeName: 'VA',
  //   displayName: 'Vatican City (VA) +379'
  // },
  // {
  //   codeNumber: '+58',
  //   codeName: 'VE',
  //   displayName: 'Venezuela (VE) +58'
  // },
  // {
  //   codeNumber: '+84',
  //   codeName: 'VN',
  //   displayName: 'Vietnam (VN) +84'
  // },
  // {
  //   codeNumber: '+681',
  //   codeName: 'WF',
  //   displayName: 'Wallis and Futuna (WF) +681'
  // },
  // {
  //   codeNumber: '+212',
  //   codeName: 'EH',
  //   displayName: 'Western Sahara (EH) +212'
  // },
  // {
  //   codeNumber: '+967',
  //   codeName: 'YE',
  //   displayName: 'Yemen (YE) +967'
  // },
  // {
  //   codeNumber: '+260',
  //   codeName: 'ZM',
  //   displayName: 'Zambia (ZM) +260'
  // },
  // {
  //   codeNumber: '+263',
  //   codeName: 'ZW',
  //   displayName: 'Zimbabwe (ZW) +263'
  // }
];

export const URL_FLAGS =
  'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/';

export const AVAILABLE_COUNTRIES = [
  {
    id: '60e4482c7cb7d4bc4849c4d5',
    placeholder: '1078286109',
    codeNumber: '+20',
    codeNumberArabic: '20+',
    codeName: 'EG',
    displayName: 'Egypt +20',
    display: true,
    name: 'Egypt',
    arabicName: 'مصر'
  },
  {
    id: 'eF-3f9FZr',
    placeholder: '12345678',
    codeNumber: '+966',
    codeNumberArabic: '966+',
    codeName: 'SA',
    displayName: 'Saudi Arabia +966',
    display: true,
    name: 'Saudi Arabia',
    arabicName: 'السعودية'
  },
  {
    codeName: 'AE'
  }
];
